import { EntityParameterType } from '$shared/constants/EntityParameterType';
import { DatasetMatchRecordFactory } from '$shared/factory/DatasetMatchRecordFactory';
import type { IDatasetMatchData } from '$shared/interfaces/api/IDatasetMatchData';
import BaseModel from '../BaseModel';
import { DatasetMatchRecord } from './DatasetMatchRecord';
import DatasetScanParam from '../DatasetScanParam';

export class DatasetMatchData extends BaseModel<IDatasetMatchData> {
  declare public positiveParameters: DatasetScanParam[];
  declare public negativeParameters: DatasetScanParam[];
  declare readonly record: DatasetMatchRecord;
  declare readonly type: string;

  constructor(type: string, response: IDatasetMatchData) {
    super(response);
    this.type = type;
    this.record = DatasetMatchRecordFactory.get(type, this.response.record);
    // setting this values for highlighting a match result paramter
    this.record.positiveParameters = this.positiveParameters;
    this.record.negativeParameters = this.negativeParameters;
  }

  public getProblems(
    nameType: EntityParameterType.FacilityName | EntityParameterType.ProviderName
  ): DatasetScanParam[] {
    const isNameHasMatch = !!DatasetScanParam.find(nameType, this.positiveParameters);
    // If any name that exisit in positive param, then we consider name is not a proble
    // even if other name params are exist in negative params.
    let nameProblem: DatasetScanParam | null = null;
    !isNameHasMatch && (nameProblem = DatasetScanParam.find(nameType, this.negativeParameters));

    const problems: (DatasetScanParam | null)[] = [nameProblem]
      .concat(DatasetScanParam.find(EntityParameterType.ProviderNpi, this.negativeParameters)) // For NPI
      .concat(DatasetScanParam.find(EntityParameterType.ProviderDea, this.negativeParameters)) // For DEA
      .concat(
        DatasetScanParam.find(EntityParameterType.ProviderCertificate, this.negativeParameters)
      ) // For Certificate
      .concat(
        DatasetScanParam.find(
          EntityParameterType.ProviderBoardCertificationNumber,
          this.negativeParameters
        )
      ); // For BoardS

    return problems.filter(Boolean) as DatasetScanParam[];
  }

  protected transformResponse(): void {
    this.positiveParameters =
      this.response.positiveParameters?.map((item) => new DatasetScanParam(item)) || [];
    this.negativeParameters =
      this.response.negativeParameters?.map((item) => new DatasetScanParam(item)) || [];
  }
}
